<template>
  <div class="forms">
    <a-modal :visible="visible" @cancel="hide()" title='延期' width='460px' @ok='visSub' :zIndex="1002">
      <a-row align='middle' justify='space-between' type='flex' style="margin-bottom:10px;">
        <label>延期天数：</label>
        <a-input-number placeholder='请输入延期天数' v-model='examineForm.days' style="width:340px;" :max="5" :min="1">
        </a-input-number>
      </a-row>
      <a-row align='middle' justify='space-between' type='flex'>
        <label>延期原因：</label>
        <a-input type="textarea" placeholder='请输入延期原因' v-model='examineForm.reason' style="width:340px;"> </a-input>
      </a-row>
    </a-modal>
    <a-modal :visible="qSee" title='签收' width='760px' :footer="null" @cancel="qSee = false">
      <a-row class="mrow">
        <a-col :span="12" class="row"><label>提醒时间:</label><span>{{ qOj.over_date }}</span></a-col>
        <a-col :span="12" class="row"><label>操作人:</label><span v-if="qOj.over_comment && qOj.over_comment.length">{{
          qOj.over_comment[0].userName }}</span></a-col>
      </a-row>
      <a-row class="mrow">
        <a-col :span="12" class="row"><label>债务人:</label><a href="javascript:void(0);" @click="link(qOj)"
            v-if="qOj.union_debtor">{{ qOj.union_debtor.realname }}</a></a-col>
        <a-col :span="12" class="row"><label>证件号码:</label><span v-if="qOj.union_debtor">{{ qOj.union_debtor.chinaid
            }}</span></a-col>
      </a-row>
      <a-row class="mrow">
        <a-col :span="12" class="row"><label>所属案件:</label><span v-if="qOj.cause">案件{{ qOj.cause.sort }}</span></a-col>
        <a-col :span="12" class="row"><label>寄出时间:</label><span>{{ qOj.ship_time }}</span></a-col>
      </a-row>
      <a-row class="mrow">
        <a-col :span="12" class="row"><label>材料类型:</label><span>{{ source[qOj.source] }}</span></a-col>
        <a-col :span="12" class="row"><label>材料名称:</label>
          <div>
            <Normap :tit="qOj.filename"></Normap>
          </div>
        </a-col>
      </a-row>
      <a-row class="mrow">
        <a-col :span="12" class="row"><label>收件人:</label><span>{{ qOj.receive_name }}</span></a-col>
        <a-col :span="12" class="row"><label>单号:</label><span>{{ qOj.ship_no }}</span></a-col>
      </a-row>
      <div class="btns">
        <a-popconfirm title="确认签收后将不再提醒" ok-text="确定" cancel-text="取消" @confirm="Confirm">
          <a-button type="primary">确认签收</a-button>
        </a-popconfirm>
        <a-button @click="visible = true;" style="margin-left:20px;" v-if="form.type == 1">未签收，延期</a-button>
      </div>
    </a-modal>
    <div class="h2">
      <div class="mid">
        <a-radio-group v-model='form.type' @change="resh()">
          <a-radio :value="1">提醒中({{ top.remindingCount }})</a-radio>
          <a-radio :value="2">已延期({{ top.remindDelayCount }})</a-radio>
        </a-radio-group>
        <a-col class="flex" :span="4">
          <label>债务人：</label>
          <a-input v-model="form.debtor_name" placeholder="请输入债务人"></a-input>
        </a-col>
        <a-col class="flex" :span="5">
          <label>债务人证件号码：</label>
          <a-input v-model="form.debtor_chinaid" placeholder="请输入证件号码"></a-input>
        </a-col>
        <a-col class="flex">
          <label>材料类型：</label>
          <a-select v-model="form.source" placeholder="请选择" class="select" style="width:140px;">
            <a-select-option value="">全部</a-select-option>
            <a-select-option :value="1">立案材料</a-select-option>
            <a-select-option :value="2">补充材料</a-select-option>
            <a-select-option :value="3">接收材料</a-select-option>
            <a-select-option :value="5">律师函</a-select-option>
          </a-select>
        </a-col>
        <div class="find">
          <a-button type="primary" icon="search" @click="resh()">查询</a-button>
          <a-button @click="reset" style="margin-left: 10px;">重置</a-button>
          <!-- <a-button type="primary" icon="plus" @click='edit=1;disType=2;visible=true;'>新增</a-button> -->
        </div>
      </div>
    </div>
    <div class="table" v-if='load'>
      <Table :getUrl='putData.url[0]' :formKey='putData.formKey' ID='id' ref='table' :query='form'
        :other='["debtor_id"]' :backAll="true" v-if='$common.AUTH("welcome:emailmsg")'>
        <template v-slot:pick='v'>
          <div class="fbtns">
            <a href="javascript:void(0);" @click="examineForm.id = v.id; qOj = v.element; qSee = true;"
              style="margin-right:10px;">查看</a>
            <a href="javascript:void(0);" @click="examineForm.id = v.id; visible = true;" v-if="form.type == 1">延期</a>
          </div>
        </template>
      </Table>
      <div class="nqx smnq" v-else>您没有该页面的访问权限，请联系管理员开通。</div>
    </div>
  </div>
</template>
<script>
import Ntxt from '@/components/textarea/ntxt'
import Table from './table.vue'
import { shipRemindDealy, shipRemindReceive } from '@/server/api'
import { Tacitly } from '@/assets/js/Tacitly'
export default {
  name: 'Email',
  props: {
    putData: Object,
    NumList: Array
  },
  data() {
    return {
      examineForm: {
        id: '',
        days: 1,
        reason: '',
      },
      load: true,
      visible: false,
      kType: 0,
      qSee: false,
      qOj: {
        debtor: {},
        over_comment: []
      },
      source: {
        1: '立案材料',
        2: '补充材料',
        3: '接收材料',
        5: '律师函'
      },
      form: {
        type: 1,
        source: "",
        debtor_realname: '',
        debtor_chinaid: '',
        stime: '',
        etime: ''
      }
    }
  },
  components: { Ntxt, Table },
  computed: {
    top() {
      return this.$store.state.Home.Top
    }
  },
  methods: {
    link(obj) {
      let name = obj.debtor_id ? 'lydetails' : 'ldetails', id = obj.debtor_id ? obj.debtor_id : obj.letters_debtor_id
      let routeUrl = this.$router.resolve({ "name": name, params: { "id": id } });
      window.open(routeUrl.href, '_blank');
    },
    Confirm() {
      shipRemindReceive({ id: this.examineForm.id }).then(e => {
        this.$message.success('已签收')
        this.hide()
        this.qSee = false;
        this.$refs.table.turnpage()
      })
    },
    hide() {
      this.examineForm = {
        id: '',
        days: 1,
        reason: '',
      };
      this.visible = false;

    },
    visSub() {
      shipRemindDealy(this.examineForm).then(e => {
        this.$message.success('已延期')
        this.$store.dispatch('Home/getKey', this.NumList)
        this.hide()
        this.$refs.table.turnpage()
      })
    },
    async resh() {
      let p = (bool) => new Promise((resolve, reject) => {
        this.load = bool;
        resolve()
      })
      await p(false)
      await p(true)

    },
    reset() {
      this.form.type = 1
      this.form.debtor_name = ''
      this.form.debtor_chinaid = ''
      this.form.source = ''
      this.resh()
    }
  }
}
</script>
<style lang="less">
.fbtns {
  display: flex;

  span {
    font-size: 14px;
    color: #1d8bfe;
    display: inline-block;
    padding-right: 10px;
    position: relative;
    cursor: pointer;
    // &::after {
    //   position: absolute;
    //   right: 0;
    //   top: 4px;
    //   content: "";
    //   width: 1px;
    //   height: 14px;
    //   background: #efefef;
    //   display: block;
    // }
    // &:nth-last-child(1) {
    //   &::after {
    //     display: none;
    //   }
    // }
  }
}
</style>
<style lang="less" scoped>
.btns {
  padding-top: 20px;
  text-align: center;
}

.row {
  display: flex;
  align-items: center;

  label {
    font-size: 14px;
    color: #333;
    width: 80px;
  }
}

.mrow {
  margin-bottom: 20px;
}

.disform {

  .fintbox {
    display: flex;
    align-items: center;
    position: relative;

    .icons {
      font-size: 20px;
      color: #2196f3;
      cursor: pointer;
      margin-left: 10px;
    }

    a {
      position: absolute;
      right: 34px;
    }
  }

  /deep/ .ant-form-item {
    margin-bottom: 14px;
  }

  /deep/ .ipt input {
    padding-right: 50px;
  }

  .file {
    width: 200px;
    height: 32px;
    border-radius: 4px;
    border: 1px solid #efefef;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    position: relative;
    margin-top: 4px;

    .tit {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 120px;
      overflow: hidden;
      height: 32px;
      margin-right: 2px;

      span {
        display: inline-block;
        width: 100px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        line-height: 32px;
      }
    }

    .log {
      width: 200px;

      span {
        width: 200px;
      }
    }

    .fbox {
      position: relative;
      color: #1d8bfe;
      white-space: nowrap;

      input {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        opacity: 0;
      }
    }
  }
}

.mid {
  display: flex;
  align-items: center;

  .flex {
    display: flex;
    align-items: center;
    white-space: nowrap;
    margin-right: 10px;
  }

  .select {
    width: 80px;
  }

  .find {
    display: flex;
    align-items: center;

    /deep/.input {
      width: 132px;
      height: 30px;

      input {
        padding: 4px 8px;
        height: 30px;
        font-size: 13px;
        line-height: 30px;
      }
    }

    /deep/.ant-btn {
      height: 30px;
      margin-left: 2px;
    }
  }
}

b.err {
  color: #f00;
}
</style>